import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=1d27bf55&scoped=true&"
import script from "./inputFile.vue?vue&type=script&lang=js&"
export * from "./inputFile.vue?vue&type=script&lang=js&"
import style0 from "./inputFile.vue?vue&type=style&index=0&id=1d27bf55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d27bf55",
  null
  
)

export default component.exports